import { render, staticRenderFns } from "./specific.vue?vue&type=template&id=7e2fcf70&scoped=true&"
import script from "./specific.vue?vue&type=script&lang=js&"
export * from "./specific.vue?vue&type=script&lang=js&"
import style0 from "./specific.vue?vue&type=style&index=0&id=7e2fcf70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2fcf70",
  null
  
)

export default component.exports